/**
 * Change App Constants
 *
 * URL parameter names used by the change-app cross-portal navigation module.
 *
 * @since 1.0.0
 * @category Constants/ChangeApp
 */

/** Query parameter name used to pass the minitoken between portals */
export const MINITOKEN_PARAM = 'minitoken';

/** Query parameter name for the origin portal's SSO client ID */
export const ORIGIN_CLIENT_ID_PARAM = 'originClientId';

/** Query parameter name for the authenticated user's ID */
export const USER_ID_PARAM = 'userId';
